export default "__VITE_ASSET__DuyJYeRr__"